import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { Transaction } from '@app/transactions/transaction';
import { FeeProvider } from '@app/transactions/components/fee-message/fee-provider';
import { ICalculatorDetail } from '@app/core/helpers/calculator-detail.helper';
import { CalculatorProBuilderHelper } from '@app/core/helpers/calculator-pro-builder.helper';
import { System } from '@app/core/resources/system';
import { Router } from '@angular/router';
import { TransactionUrlService } from '@app/transactions/transaction-url.service';
import { SystemsUpdatedService } from '@app/transactions/services/systems-updated.service';

@Component({
    selector: 'app-fee-banner',
    templateUrl: './fee-banner.component.html',
    styleUrls: ['./fee-banner.component.scss']
})
export class FeeBannerComponent implements OnChanges {
    @Input() public transaction: Transaction = new Transaction();
    private feeProvider!: FeeProvider;
    private calculatorProBuilderHelper: CalculatorProBuilderHelper = new CalculatorProBuilderHelper();
    public details!: ICalculatorDetail | null;
    public feeSend: number = 0;
    public feeReceive: number = 0;
    public system1: System = new System();
    public system2: System = new System();

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        public systemsUpdatedService: SystemsUpdatedService
    ) {}

    public ngOnChanges(): void {
        this.systemsUpdatedService.transactionUpdatedSource.asObservable().subscribe(() => {
            this.details = this.calculatorProBuilderHelper.setTransaction(this.transaction).getPositionNumber(4);
            this.system1 = this.transaction.relationships.system1.data ?? new System();
            this.system2 = this.transaction.relationships.system2.data ?? new System();
            this.feeProvider = new FeeProvider();
            this.feeProvider.setTransaction(this.transaction);
            this.calculateFee();
        });
    }

    private calculateFee(): void {
        this.feeSend = this.feeProvider.getBySystem('receive', 1).getFee();
        this.feeReceive = this.feeProvider.getBySystem('send', 2).getFee();
        this.changeDetectorRef.detectChanges();
    }

    public goToTransactionForm(): void {
        this.router.navigate([TransactionUrlService.getUrl(this.transaction, 'b')]);
    }

    public setUrlRedirectByPosition(positionSystem: string): void {
        let urlRedirect: string =
            '/b/' + this.system1.id + '/' + this.system2.id + '/' + (this.transaction.attributes.amount1 - this.feeSend);
        if (positionSystem === 'receive') {
            urlRedirect = '/b/' + this.system1.id + '/' + this.system2.id + '/0/' + (this.transaction.attributes.amount2 + this.feeReceive);
            this.router.navigate([urlRedirect]);
        }
        this.router.navigate([urlRedirect]);
    }
}
